<div class="line-winloss">
  <div class="container-fluid py-3">

    <!-- Header -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
      <div>
        <button *ngIf="agent_code || trail.length" class="btn btn-sm btn-outline-secondary mb-2" (click)="goUp()">
          <i class="bi bi-arrow-left"></i> Back
        </button>
        <h4 class="mb-0">
          <i class="bi bi-diagram-3 text-success"></i> Line Win/Loss <small class="text-muted">线路输赢</small>
        </h4>
      </div>
      <div class="d-flex flex-row align-items-center gap-2 mt-3 mt-md-0 flex-wrap">
        <div class="input-group input-group-sm wl-agent-search">
          <span class="input-group-text"><i class="bi bi-person-badge"></i></span>
          <input type="text" class="form-control form-control-sm" placeholder="Agent code…"
            [(ngModel)]="search_agent" (keyup.enter)="searchByAgent()">
          <button class="btn btn-outline-primary" (click)="searchByAgent()" title="Go to agent line">
            <i class="bi bi-arrow-right-circle"></i>
          </button>
          <button *ngIf="agent_code" class="btn btn-outline-secondary" (click)="clearAgentSearch()" title="Show all lines">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="from_date">
        <span>-</span>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="to_date">
        <button class="btn btn-sm btn-primary" (click)="filter()"><i class="bi bi-search"></i> Search</button>
      </div>
    </div>

    <!-- Filter error (e.g. invalid agent code) -->
    <div *ngIf="error_msg" class="alert alert-warning py-2 px-3 mb-3">
      <i class="bi bi-exclamation-triangle"></i> {{ error_msg }}
    </div>

    <!-- Breadcrumb trail (narrow in / back) -->
    <nav class="wl-breadcrumb mb-3">
      <span class="crumb" (click)="jumpTo(-1)">
        <i class="bi bi-house-door"></i> Company
      </span>
      <ng-container *ngFor="let t of trail; let i = index">
        <i class="bi bi-chevron-right sep"></i>
        <span class="crumb" (click)="jumpTo(i)">{{ t.name || t.code || 'Company' }}</span>
      </ng-container>
      <ng-container *ngIf="agent_code">
        <i class="bi bi-chevron-right sep"></i>
        <span class="crumb current">{{ root.name || root.code }}</span>
      </ng-container>
    </nav>

    <!-- Summary cards -->
    <div class="row g-3 mb-3" *ngIf="summary">
      <div class="col-6 col-xl-3">
        <div class="stat-card" [ngClass]="summary.house_winloss >= 0 ? 'sc-green' : 'sc-red'">
          <div class="stat-label">Line Win/Loss (House)</div>
          <div class="stat-value">{{ summary.house_winloss | number:'1.2-2' }}</div>
          <div class="stat-sub">
            <span class="badge" [ngClass]="statusBadgeClass(summary.status)">{{ statusLabel(summary.status) }}</span>
          </div>
        </div>
      </div>
      <div class="col-6 col-xl-3">
        <div class="stat-card sc-blue">
          <div class="stat-label">Turnover</div>
          <div class="stat-value">{{ summary.turnover | number:'1.2-2' }}</div>
        </div>
      </div>
      <div class="col-6 col-xl-3">
        <div class="stat-card sc-red-soft">
          <div class="stat-label">Lines Players Winning</div>
          <div class="stat-value">{{ summary.winning_lines }}</div>
        </div>
      </div>
      <div class="col-6 col-xl-3">
        <div class="stat-card sc-green-soft">
          <div class="stat-label">Lines Players Losing</div>
          <div class="stat-value">{{ summary.losing_lines }}</div>
        </div>
      </div>
    </div>

    <!-- Legend -->
    <div class="wl-legend mb-2">
      <span><i class="dot dot-red"></i> Players Winning (house pays out)</span>
      <span><i class="dot dot-green"></i> Players Losing (house keeps)</span>
      <span class="text-muted">Win/Loss shown from the company/house side.</span>
    </div>

    <!-- Tree -->
    <div class="card">
      <div class="wl-head d-none d-md-flex">
        <span class="c-name">Downline</span>
        <span class="c-num">Turnover</span>
        <span class="c-num">Line Win/Loss</span>
        <span class="c-status">Status</span>
        <span class="c-action"></span>
      </div>

      <div *ngIf="is_loading" class="text-center text-muted py-5">
        <i class="bi bi-hourglass-split"></i> Loading...
      </div>

      <div *ngIf="!is_loading && tree.length === 0" class="text-center text-muted py-5">
        <i class="bi bi-inbox fs-2 d-block mb-2"></i> No agent lines found
      </div>

      <ng-container *ngIf="!is_loading">
        <ng-container *ngFor="let n of tree">
          <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: n, level: 0 }"></ng-container>
        </ng-container>
      </ng-container>
    </div>

  </div>
</div>

<!-- Recursive node row (max depth 3 returned by the API) -->
<ng-template #nodeTpl let-node let-level="level">
  <div class="wl-row" [class.is-agent]="node.is_agent" [class.row-drillable]="node.can_drill">
    <span class="c-name" [style.padding-left.px]="10 + level * 20">
      <i class="bi" [ngClass]="node.is_agent ? 'bi-diagram-3 text-success' : 'bi-person'"></i>
      <span *ngIf="node.is_online" class="online-dot"></span>
      <strong>{{ node.code }}</strong>
      <small class="text-muted ms-1 d-none d-sm-inline">{{ node.name }}</small>
      <span *ngIf="node.is_agent" class="badge bg-light text-dark ms-1 lvl">L{{ level + 1 }}</span>
    </span>
    <span class="c-num d-none d-md-inline">{{ node.turnover | number:'1.2-2' }}</span>
    <span class="c-num" [ngClass]="statusClass(node.status)">
      <strong>{{ node.house_winloss | number:'1.2-2' }}</strong>
    </span>
    <span class="c-status">
      <span class="badge" [ngClass]="statusBadgeClass(node.status)">{{ statusLabel(node.status) }}</span>
    </span>
    <span class="c-action">
      <button *ngIf="node.can_drill" type="button" class="wl-drill-btn"
        (click)="drillInto(node)" title="Narrow into {{ node.code }}'s line">
        <span class="wl-drill-label d-none d-md-inline">Narrow In</span>
        <i class="bi bi-chevron-right"></i>
      </button>
      <span *ngIf="!node.can_drill" class="wl-leaf d-none d-md-inline" title="End of line">—</span>
    </span>
  </div>
  <ng-container *ngFor="let child of node.children">
    <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: child, level: level + 1 }"></ng-container>
  </ng-container>
</ng-template>
